import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "membershipBtn",
    "form",
    "submitBtn",
    "successMessage",
    "errorMessage",
    "errorList",
  ]

  declare readonly membershipBtnTargets: HTMLButtonElement[]
  declare readonly formTarget: HTMLFormElement
  declare readonly submitBtnTarget: HTMLButtonElement
  declare readonly successMessageTarget: HTMLElement
  declare readonly errorMessageTarget: HTMLElement
  declare readonly errorListTarget: HTMLElement

  private membershipType = "partner"

  selectMembership(event: Event) {
    const btn = event.currentTarget as HTMLButtonElement
    const type = btn.dataset.membership
    if (!type) return

    this.membershipType = type
    this.membershipBtnTargets.forEach(b => {
      b.classList.toggle("active", b.dataset.membership === type)
    })
  }

  async submitOffer(event: Event) {
    event.preventDefault()
    this.submitBtnTarget.disabled = true
    this.hideMessages()

    const formData = new FormData(this.formTarget)
    const body = {
      url: formData.get("url") ?? "",
      spinner: formData.get("spinner") ?? "",
      offer: {
        company_name: formData.get("company_name"),
        person_first_name: formData.get("person_first_name"),
        person_last_name: formData.get("person_last_name"),
        email: formData.get("email"),
        phone: formData.get("phone"),
        membership_model: this.membershipType,
        employee_count: parseInt(formData.get("employee_count") as string, 10) || 150,
      }
    }

    try {
      const response = await fetch("/registration/offers", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken(),
        },
        body: JSON.stringify(body),
      })

      if (response.ok) {
        this.successMessageTarget.hidden = false
        this.formTarget.reset()
      } else {
        const data = await response.json()
        this.showErrors(data.errors || ["Ein Fehler ist aufgetreten."])
      }
    } catch {
      this.showErrors(["Verbindungsfehler. Bitte versuchen Sie es erneut."])
    } finally {
      this.submitBtnTarget.disabled = false
    }
  }

  private showErrors(errors: string[]) {
    this.errorMessageTarget.hidden = false
    this.errorListTarget.innerHTML = errors.map(e => `<li>${e}</li>`).join("")
  }

  private hideMessages() {
    this.successMessageTarget.hidden = true
    this.errorMessageTarget.hidden = true
  }

  private csrfToken(): string {
    return document.querySelector("meta[name='csrf-token']")?.getAttribute("content") || ""
  }
}
